"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
const extractUrlExtension_1 = require("./extractUrlExtension");
const plexRouteV2_1 = require("./plexRouteV2");
const plexUrl_1 = require("./plexUrl");
const plexUrlParams_1 = require("./plexUrlParams");
class Routes {
}
exports.Routes = Routes;
Routes.extractDeprecatedPlexUrlParams = plexUrlParams_1.extractPlexUrlParams;
Routes.searchWithDeprecatedPlexUrlParams = plexUrlParams_1.searchWithPlexUrlParams;
Routes.deprecatedPlexUrl = plexUrl_1.plexUrl;
Routes.extractUrlExtension = extractUrlExtension_1.extractUrlExtension;
Routes.urlToRoute = plexRouteV2_1.urlToRoute;
Routes.routeToUrl = plexRouteV2_1.routeToUrl;
Routes.routeToUrlComponents = plexRouteV2_1.routeToUrlComponents;
Routes.SETTINGS_PATH = '/settings';
Routes.GENERAL_SETTINGS_PATH = Routes.SETTINGS_PATH + '/general';
Routes.PROFILE_SETTINGS_PATH = Routes.SETTINGS_PATH + '/profile';
Routes.NOTIFICATIONS_SETTINGS_PATH = Routes.SETTINGS_PATH + '/notifications';
Routes.ACCOUNT_SETTINGS_PATH = Routes.SETTINGS_PATH + '/account';
Routes.SECURITY_SETTINGS_PATH = Routes.SETTINGS_PATH + '/security';
Routes.INTEGRATIONS_SETTINGS_PATH = Routes.SETTINGS_PATH + '/integrations';
Routes.BILLING_SETTINGS_PATH = Routes.SETTINGS_PATH + '/billing';
Routes.TEAM_SETTINGS_PATH = Routes.SETTINGS_PATH + '/team';
Routes.LOGGED_OUT_PATH = '/logged-out';
Routes.PERSONAL_GMAIL_PATH = '/personal-gmail';
Routes.HOME_PATH = '/';
Routes.PLEX_FEED_PREFIX_PATH = '/home';
Routes.PLEX_PERMALINK_PATH = '/plex/:plexId';
Routes.PLEX_POST_PERMALINK_PATH = '/plex/:plexId/post/:postId';
Routes.LOGIN_API_PATH = '/api/auth/google';
Routes.LOGOUT_API_PATH = '/api/logout ';
Routes.PRIVATE_ASSET_PATH = '/api/assets';
Routes.PLEX_DIALOG_PARAM = 'dialog';
Routes.PLEX_FEED_PATH = '/home/feed';
Routes.PLEX_BASE_PATH = '/home/base';
Routes.PLEX_TASKS_PATH = '/home/tasks';
Routes.NOTIFICATIONS_PATH = '/home/notifications';
Routes.PLEX_SEARCH_PATH = '/home/search';
Routes.TIMELINE_PATH = '/home/timeline';
Routes.NOT_FOUND_PATH = '/not-found';
Routes.ONBOARDING = '/welcome';
Routes.PLEX_SELECTED_ITEM_PARAM = plexUrlParams_1.PLEX_SELECTED_ITEM_PARAM;
Routes.SIGNUP_EMAIL_PARAM = 'signupEmail';
Routes.AMPLITUDE_API_KEY_PATH = '/api/analytics/token';
//# sourceMappingURL=Routes.js.map